import React from 'react';
import { plantScoreClass, SCORE_HINT } from '../utils/plantScore';

// ScoreBadge shows a room's or site's plant score, or nothing when it has none.
const ScoreBadge = ({ score, testId, className = '' }) => {
        if (score == null) return null;
        return (
                <span data-testid={testId} title={SCORE_HINT} className={`inline-flex items-baseline gap-1 ${className}`}>
                        <span className={`font-semibold ${plantScoreClass(score)}`}>{score}</span>
                        <span className="text-xs font-normal text-text-weak">score</span>
                </span>
        );
};

export default ScoreBadge;
